import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isUserPersonalizationAllowed } from 'owa-theme';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let DarkModeOption: LazyOption = createLazyOption(
    {
        key: 'darkMode',
        titleStringKey: 'options_theme_darkmode_toggle',
        searchTermsStringKey: 'options_theme_darkmode_toggle',
        isHidden: () => !isDarkModeEnabled(),
        allowedOptionKeys: ['Theme'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export function isDarkModeEnabled(): boolean {
    return isFeatureEnabled('fwk-darkTheme') && isUserPersonalizationAllowed();
}
export default DarkModeOption;
